import React from "react";
import { TerminalViewPickupSummaryTilesModel } from "../../../../app/data/pickup/models";
import { PicklistsSummaryTile, PicklistsSummaryTileTypes } from "./pickupSummaryTile";
import "./pickupSummary.scss";

interface PicklistsSummaryProps {
    picklistSummary: TerminalViewPickupSummaryTilesModel,
    isLoading: boolean
}

export const PicklistsSummary: React.FC<PicklistsSummaryProps> = ({ picklistSummary, isLoading }) => {

    return (<div className="xgs-pickupsummary-summary">
        <PicklistsSummaryTile
            type={PicklistsSummaryTileTypes.created}
            isLoading={isLoading}
            title="Pickups Created"
            value={(picklistSummary && picklistSummary.created) ? `${picklistSummary?.created}` : "0"}
        />
        <PicklistsSummaryTile
            type={PicklistsSummaryTileTypes.completed}
            isLoading={isLoading}
            title="Pickups Completed"
            value={(picklistSummary && picklistSummary.completed) ? `${picklistSummary?.completed}` : "0"}
        />
        <PicklistsSummaryTile
            type={PicklistsSummaryTileTypes.missed}
            isLoading={isLoading}
            title="Pickups Missed"
            value={(picklistSummary && picklistSummary.missed) ? `${picklistSummary?.missed}` : "0"}
        />
        <PicklistsSummaryTile
            type={PicklistsSummaryTileTypes.rescheduled}
            isLoading={isLoading}
            title="Pickups Rescheduled"
            value={(picklistSummary && picklistSummary.rescheduled) ? `${picklistSummary?.rescheduled}` : "0"}
        />
        <PicklistsSummaryTile
            type={PicklistsSummaryTileTypes.cancelled}
            isLoading={isLoading}
            title="Pickups Canceled"
            value={(picklistSummary && picklistSummary.cancelled) ? `${picklistSummary?.cancelled}` : "0"}
        />
    </div>
    )
};